module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "photo_in"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs'), _c('a', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("> "), _c('span', {
    staticStyle: {
      "padding-left": "4px"
    }
  }, [_vm._v(_vm._s(_vm.photobread))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box"
  }, [_vm._l((_vm.photos), function(photo, index) {
    return (_vm.inCurrentPage(index)) ? _c('div', {
      key: index,
      staticClass: "photo_box"
    }, [_c('div', {
      staticClass: "photo_box_icon"
    }, [_vm._v("\n          " + _vm._s(photo.memo) + "\n          "), _vm._m(0, true)]), _vm._v(" "), _c('a', {
      attrs: {
        "href": photo.fileUrl,
        "data-lightbox": "pages"
      }
    }, [_vm._m(1, true)]), _vm._v(" "), _c('div', {
      staticClass: "photo_box_pic"
    }, [_c('img', {
      attrs: {
        "src": photo.fileUrl
      }
    })])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center ml20"
  }, [_c('Page', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "total": _vm.photos.length,
      "page-size": _vm.pagesize
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt10"
  }, [_c('button', {
    staticClass: "photo_btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("more")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "photo_box_icon2"
  }, [_c('button', {
    staticClass: "view_ph",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bc078b7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PhotoIn.vue
// module id = 1210
// module chunks = 4